import About from "./components/About";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import Home from "./components/Home";
import Navbar from "./components/Navbar";
import Skills from "./components/Skills";
import Experience from "./components/Experience";
import Work from "./components/Work";
import Review from "./components/Review"
function App() {
  return (
    <div
      style={{ height: '100%' }}
    >
      <Navbar />

      <div
        style={{ height: '100%' }}
      >
        <Home />
      </div>

      <div
        style={{ height: '100%' }}
      >
        <About />
      </div>

      <div
        style={{ height: '100%' }}
      >
        <Skills />
      </div>

      <div
        style={{ height: '100%' }}
      >
        <Experience />
      </div>

      <div
        style={{ height: '100%' }}
      >
        <Work />
      </div>
      
      <div
        style={{ height: '100%' }}
      >
        <Review/>
      </div>
      <div
        style={{ height: '100%' }}
      >
        <Contact />
      </div>
      
      <Footer />
    </div>
  );
}

export default App;
